// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.mjs";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as MediaApiModel$PorterinFeature from "../../../../shared/media/domain/api-models/MediaApiModel.mjs";
import * as SharedApiModel$PorterinFeature from "../../../../shared/core/domain/api-models/SharedApiModel.mjs";

function downloadAppBanner_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var text = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "text"), null));
  if (text.TAG === /* Ok */0) {
    var cta = SharedApiModel$PorterinFeature.know_more_cta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "cta"), null));
    if (cta.TAG === /* Ok */0) {
      var image = MediaApiModel$PorterinFeature.image_long_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "image"), null));
      if (image.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  text: text._0,
                  cta: cta._0,
                  image: image._0
                }
              };
      }
      var e = image._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".image" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = cta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".cta" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = text._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".text" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function attributes_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var heading = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "heading"), null));
  if (heading.TAG === /* Ok */0) {
    var download_app_banner = downloadAppBanner_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "download_app_banner"), null));
    if (download_app_banner.TAG === /* Ok */0) {
      var track_order_button_text = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "track_order_button_text"), null));
      if (track_order_button_text.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  heading: heading._0,
                  download_app_banner: download_app_banner._0,
                  track_order_button_text: track_order_button_text._0
                }
              };
      }
      var e = track_order_button_text._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".track_order_button_text" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = download_app_banner._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".download_app_banner" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = heading._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".heading" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function data_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var attributes = attributes_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "attributes"), null));
  if (attributes.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              attributes: attributes._0
            }
          };
  }
  var e = attributes._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".attributes" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var data = data_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "data"), null));
  if (data.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              data: data._0
            }
          };
  }
  var e = data._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".data" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  downloadAppBanner_decode ,
  attributes_decode ,
  data_decode ,
  t_decode ,
}
/* No side effect */
